import { Fragment } from "react";
import type { FunctionComponent, ReactNode } from "react";
import { graphql, useFragment } from "react-relay";

import { notEmpty } from "shared/lib/utils";

import type { authorShortBioArticle$key } from "scmp-app/queries/__generated__/authorShortBioArticle.graphql";

import { AuthorBioContainer } from "./styles";

export type Props = {
  children?: ReactNode;
  reference: authorShortBioArticle$key;
};

export const AuthorShortBio: FunctionComponent<Props> = ({ reference: reference_, ...attribs }) => {
  const { authors } = useFragment(
    graphql`
      fragment authorShortBioArticle on Article {
        authors {
          shortBio
        }
      }
    `,
    reference_,
  );

  if (authors?.length && authors.length > 1) return null;

  return (
    <AuthorBioContainer {...attribs}>
      {authors?.filter(notEmpty)?.map((author, index) => (
        <Fragment key={index}>{author.shortBio} </Fragment>
      ))}
    </AuthorBioContainer>
  );
};

AuthorShortBio.displayName = "AuthorShortBio";
